// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","tagsFormGroups":"BYVVVXzRJ4Cea2wp2FrEO"};